export default __webpack_public_path__ + "static/media/newlogo.79319f44.png";